import { SectionDetails } from "@components/Modules/HeaderNew/headerMenuConstants";
import { findStyleBySectionAndSubCategory } from "@helper/utils";
import { List, ListItem } from "@sphtech/sph-web-ui/elements/List";
import cx from "classnames";
import { Link, useLocation } from "react-router";

type SubSectionNavListProps = {
  items: SectionDetails[] | undefined;
  displaySection: string;
};

export function SubSectionNavList({
  items,
  displaySection,
}: SubSectionNavListProps) {
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isMobWebView = searchParams.get("mobwebview");

  const isActive = (location: string): boolean => {
    const pathnameOnly = location.split("?")[0];
    return pathname === pathnameOnly;
  };

  const { selectedColor } =
    findStyleBySectionAndSubCategory(displaySection) || {};
  if (items === undefined) {
    if (!isMobWebView) {
      return (
        <div
          className={`border-b-2 lg:border-t-2 lg:border-b-0 border-${selectedColor}`}
        ></div>
      );
    }
    return null;
  }

  return (
    <List
      testId="sub-section-nav"
      className={`flex items-center gap-[28px] lg:gap-[36px] pb-2 lg:pb-[5px] lg:pt-[12px]
        overflow-x-scroll lg:overflow-visible
        border-b-2 lg:border-b-0 lg:border-t-2 border-${items[0].selectedColor}`}
    >
      {items.map((item: SectionDetails, index: number) => (
        <ListItem
          key={index}
          testId="sub-section-nav-item"
          className="cursor-pointer flex items-center justify-center text-sm lg:text-xs"
        >
          <div className={`flex items-center gap-xxs min-w-max text-nowrap`}>
            <Link
              reloadDocument
              key={index}
              to={item.url}
              className={cx(`
                ${
                  isActive(item.url)
                    ? `text-${item.selectedColor} font-semibold`
                    : "text-text-muted font-regular"
                }`)}
              {...(item.newTab && { target: "_blank" })}
            >
              {item.title}
            </Link>
          </div>
        </ListItem>
      ))}
    </List>
  );
}
